import styled, { css } from 'styled-components';
export const WelcomeStyle = css `
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: ${({ theme }) => theme.spacing.xl}px;
`;
export const ConversationStyle = css `
  max-height: 100%;
`;
export const AssistantChatShell = styled.div `
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  height: 100%;
  min-height: 0;
  background: ${({ theme }) => theme.colors.white_2};
`;
export const TitleRow = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: fit-content;
  max-width: 100%;
  align-self: flex-start;
  box-sizing: border-box;
  padding: ${({ theme }) => `${theme.spacing.lg}px ${theme.spacing.lg}px 0`};
  flex-shrink: 0;
`;
export const ConversationIndicatorsContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
  position: sticky;
  top: 0;
  z-index: 3;
`;
export const ConversationContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  ${({ $hasConversation }) => $hasConversation ? ConversationStyle : WelcomeStyle};
  transition: max-height 0.3s ease;
  width: 100%;
  background: ${({ theme }) => theme.colors.white_2};
`;
export const ProfileContextControl = styled.div `
  width: min(100%, ${({ theme }) => theme.buttons.width_large});
  flex-shrink: 0;
`;
export const ProfileConversationContextBar = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.sm}px
    ${({ theme }) => theme.spacing.xl}px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_5};
  background: ${({ theme }) => theme.colors.white_2};
  flex-shrink: 0;
`;
export const ErrorContainer = styled.div `
  padding: ${({ theme }) => theme.spacing.md}px;
  margin: ${({ theme }) => theme.spacing.md}px;
  background: ${({ theme }) => theme.colors.red_5};
  border: 1px solid ${({ theme }) => theme.colors.red_4};
  border-radius: ${({ theme }) => theme.border_radius.md};
  color: ${({ theme }) => theme.colors.error};
`;
export const AssistantChatHeader = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-items: center;
`;
